import { Button, Box } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Modal from "../../components/dialog/Modal";
import GenericPicker from "../generic-picker/GenericPicker";
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next";

function GenericPickerModal(props) {

  const [t, i18n] = useTranslation()
  const [selection, setSelection] = useState([])

  const handleSelection = newSelection => {
    setSelection(newSelection);
  };

  return (
    <Modal
      title={props.title}
      open={props.open}
      fullWidth={true}
      fixedHeight={true}
      actions={
        <Box>
          <Button color="secondary" onClick={props.handleCancel}>
            {t('common.cancel')}
          </Button>
          <Button
            color="secondary"
            onClick={() => props.handleDone(selection)}
          >
            {t('common.done')}
          </Button>
        </Box>
      }
    >
      <GenericPicker
        selected={props.selected}
        handleSelection={handleSelection}
        searchTitle={props.searchTitle}
        getAllData={props.getAllData}
        data={props.data}
        idField={props.idField}
        valueField={props.valueField}
        secondaryValueField={props.secondaryValueField}
        currentSelection={props.currentSelection}
        searchField={props.searchField}
        secondaryFields={props.secondaryFields}

        hasNextPage={props.hasNextPage}
        isNextPageLoading={props.isNextPageLoading}
        loadNextPage={props.loadNextPage}
        infiniteLoading={props.infiniteLoading}
        searchValue={props.searchValue}
        filterFunction={props.filterFunction}
        filterData={props.filterData}
        filterLabel={props.filterLabel}
        singleSelection={props.singleSelection}
      />
    </Modal>
  );
}

GenericPickerModal.propTypes = {
  title: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  handleCancel: PropTypes.func.isRequired,
  handleDone: PropTypes.func.isRequired,
  selected: PropTypes.arrayOf(PropTypes.string).isRequired,
  handleSelection: PropTypes.func.isRequired,
  searchTitle: PropTypes.string,
  searchField: PropTypes.string,
  getAllData: PropTypes.func.isRequired,
  data: PropTypes.array.isRequired,
  idField: PropTypes.string.isRequired,
  valueField: PropTypes.string.isRequired,
  secondaryValueField: PropTypes.string,
  currentSelection: PropTypes.arrayOf(PropTypes.string).isRequired,
  secondaryFields: PropTypes.arrayOf(PropTypes.string),
  filterFunction: PropTypes.func,
  filterData: PropTypes.array,
  filterLabel: PropTypes.string,
  singleSelection: PropTypes.bool
}

export default GenericPickerModal